import React from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt-br';
import dayjs, { Dayjs } from "dayjs"
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend dayjs with the plugins
dayjs.extend(utc);
dayjs.extend(timezone);


interface Props {
  onChange: (date: Dayjs | null) => void;
  value: Dayjs | null;
  dateTime?: boolean;
  label?: string;
  minDate?: boolean;
  width?: string;
  height?: string;
}

export default function StyledDatePicker(props: Props) {
  dayjs.tz.setDefault('America/Sao_Paulo');

  const applyMinDate = () => {
    if (props.minDate) {
      const minDate = dayjs().startOf('day')

      return minDate
    }
    return undefined
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br" >
      {props.dateTime ?
        <DateTimePicker
          label={props?.label}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: "18px",
              height: props.height ?? '56px',
              width: props.width ?? '100%',
              backgroundColor: '#ffffff',
              boxShadow: 'inset 0 1px 2px rgba(19, 34, 56, 0.03)',
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: '#d8e0ea',
            },
            "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: '#c1ccd9',
            },
            "& .MuiInputBase-root.Mui-focused": {
              boxShadow: '0 0 0 4px rgba(255, 203, 0, 0.18)',
              "& .MuiOutlinedInput-notchedOutline": {
                border: '1px solid rgba(240, 184, 0, 0.9)',
              },
            },
            "& .MuiInputLabel-root": {
              color: '#5f6c7b',
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: '#132238',
            },
          }}
          onChange={props.onChange}
          value={props.value}
          minDateTime={applyMinDate()}
        />
        :
        <DatePicker
          label={props?.label}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: "18px",
              height: props.height ?? '56px',
              width: props.width ?? '100%',
              backgroundColor: '#ffffff',
              boxShadow: 'inset 0 1px 2px rgba(19, 34, 56, 0.03)',
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: '#d8e0ea',
            },
            "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: '#c1ccd9',
            },
            "& .MuiInputBase-root.Mui-focused": {
              boxShadow: '0 0 0 4px rgba(255, 203, 0, 0.18)',
              "& .MuiOutlinedInput-notchedOutline": {
                border: '1px solid rgba(240, 184, 0, 0.9)',
              },
            },
            "& .MuiInputLabel-root": {
              color: '#5f6c7b',
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: '#132238',
            },
          }}
          onChange={props.onChange}
          value={props.value}
          minDate={applyMinDate()}
        />
      }
    </LocalizationProvider>
  )
}
